"use client"

import { wrap } from "@reatom/core"
import {
  type GachaApiOptions,
  type GachaMachinesResponse,
  fetchGachaJson,
  getCollectorCryptGachaBaseUrl,
} from "./gacha-api"
import { type GachaMachineView, mapGachaMachine } from "./gacha-data"

export async function fetchGachaMachinesStock({
  machines,
  apiOptions,
}: {
  machines: readonly GachaMachineView[]
  apiOptions?: GachaApiOptions
}) {
  const response = await wrap(
    fetchGachaJson<GachaMachinesResponse>("/machines", undefined, apiOptions),
  )
  const stockByCode = new Map(
    response.machines.map((machine) => [machine.code, machine]),
  )

  // Stock refreshes retain the status loaded with the catalogue. New packs need
  // an initial status read before they can be offered for purchase.
  return machines.flatMap((previous) => {
    const machine = stockByCode.get(previous.code)
    return machine
      ? [
          mapGachaMachine(machine, {
            apiBaseUrl: getCollectorCryptGachaBaseUrl(apiOptions),
            status: { isOpen: previous.isOpen },
          }),
        ]
      : []
  })
}
